import React from "react";

const PROFILE = {
  companyName: {
    JP: "株式会社ふじやま",
    EN: "Fujiyama, Inc.",
    ZH: "Fujiyama, Inc.",
  },
  established: {
    JP: "2017年7月",
    EN: "July 2017",
    ZH: "2017年7月",
  },
  capital: {
    JP: "10万円",
    EN: "¥100,000",
    ZH: "10万日元",
  },
  representative: {
    JP: "塚本 華",
    EN: "Hana Tsukamoto",
    ZH: "Hana Tsukamoto",
  },
  business: {
    JP: "日本語教育コンテンツの企画・アニメーション制作・編集、およびスマートフォン向け語学学習アプリの開発・運営",
    EN: "Planning, animation production, and video editing for Japanese language educational content, as well as the development and operation of mobile language learning applications.",
    ZH: "日语教育内容策划与动画制作，智能手机语言学习应用的开发与运营。",
  },
  address: {
    JP: "〒107-0061　東京都港区北青山一丁目3番1号　3階",
    EN: "3F, 1-3-1 Kitaaoyama, Minato-ku, Tokyo 107-0061, Japan",
    ZH: "日本东京都港区北青山一丁目3番1号 3楼　邮编107-0061",
  },
  trademark: {
    JP: "『はなぴん』・『えみまる』は商標登録しています。\n商標登録7062922, 登録7062923, 登録7062924, 登録7062925（日本）\n商标注册证 第89080750号, 第89080744号, 第89080747号（中国）",
    EN: "'Hanapin' and 'Emimaru' are registered trademarks.\nReg. No. 7062922, 7062923, 7062924, 7062925 (Japan)\nReg. No. 89080750, 89080744, 89080747 (China)",
    ZH: "『はなぴん』・『えみまる』为已注册商标。\n日本注册番号 7062922, 7062923, 7062924, 7062925\n中国商标注册证 第89080750号, 第89080744号, 第89080747号",
  },
  bank: {
    JP: "みずほ銀行　飯田橋支店",
    EN: "Mizuho Bank, Iidabashi Branch",
    ZH: "Mizuho Bank, Iidabashi Branch",
  },
};
// ─────────────────────────────────────────────────────────────────────────────

function SectionHeading({ children }) {
  return (
    <h2 className="text-xl font-bold text-gray-800 border-l-4 border-[#b5435f] pl-3 mb-6">
      {children}
    </h2>
  );
}

function Row({ label, value }) {
  return (
    <tr className="border-t border-gray-100">
      <th className="py-3.5 pr-6 text-left align-top w-36 md:w-44">
        <span className="text-xs font-bold text-gray-400 uppercase tracking-wider leading-relaxed">
          {label}
        </span>
      </th>
      <td className="py-3.5 text-sm text-gray-700 leading-relaxed align-top whitespace-pre-line">
        {value}
      </td>
    </tr>
  );
}

export default function About({ language, texts }) {
  const p = texts?.about?.profile ?? {};

  // Pick value by current language, fall back to JP
  const v = (key) => PROFILE[key]?.[language] ?? PROFILE[key]?.JP ?? "";

  // Pick label: from i18n if available, otherwise hardcoded fallback
  const L = (key, jp, zh, en) =>
    p[key] || (language === "JP" ? jp : language === "ZH" ? zh : en);

  return (
    <div className="w-full bg-[#fffaf0] pt-28 pb-24">
      <div className="max-w-2xl mx-auto px-6">

        {/* ── What is Hanapin ── */}
        <div className="mb-14">
          <SectionHeading>
            {language === "JP" ? "はなぴんって何？"
              : language === "ZH" ? "《樱花老师》是什么？"
              : <>What is <em>Hanapin</em>?</>}
          </SectionHeading>
          <p className="text-sm text-gray-600 leading-relaxed">
            {texts?.about?.hanapin}
          </p>
        </div>

        {/* ── About Fujiyama ── */}
        <div className="mb-14">
          <SectionHeading>
            {language === "JP" ? "株式会社ふじやまについて"
              : language === "ZH" ? "关于 Fujiyama, Inc."
              : "About Fujiyama, Inc."}
          </SectionHeading>
          <p className="text-sm text-gray-600 leading-relaxed">
            {texts?.about?.fujiyama}
          </p>
        </div>

        {/* ── 会社概要 ── */}
        <div>
          <SectionHeading>
            {language === "JP" ? "会社概要"
              : language === "ZH" ? "公司简介"
              : "Company Profile"}
          </SectionHeading>

          <table className="w-full">
            <tbody>
              <Row label={L("companyName",    "会社名",       "公司名称",     "Company Name")}   value={v("companyName")} />
              <Row label={L("established",    "設立",         "成立时间",     "Established")}    value={v("established")} />
              <Row label={L("capital",        "資本金",       "注册资本",     "Capital")}        value={v("capital")} />
              <Row label={L("representative", "代表",         "代表",         "Representative")} value={v("representative")} />
              <Row label={L("business",       "事業内容",     "业务内容",     "Business")}       value={v("business")} />
              <Row label={L("address",        "所在地",       "地址",         "Address")}        value={v("address")} />
              <Row label={L("trademark",      "商標",         "商标",         "Trademark")}      value={v("trademark")} />
              <Row label={L("bank",           "主要取引銀行", "主要往来银行", "Main Bank")}      value={v("bank")} />
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
